import { NgModule } from "@angular/core";
import { FilterPipe } from "./filter.pipe";
import { SafePipe } from "src/app/_pipes/safeUrl.pipe";
import { StartsWithFilterPipe } from "./startsWithFilter";
@NgModule({
  declarations: [FilterPipe, SafePipe, StartsWithFilterPipe],
  imports: [],
  exports: [FilterPipe, SafePipe, StartsWithFilterPipe],
})
export class PipeModule {}
